"use client"
import { useState } from "react"
import { Bell, BellOff, Lock } from "lucide-react"
import { useRouter } from "next/navigation"

interface Props {
  openCallId: string
  initialAlerted: boolean
  isLoggedIn: boolean
  isSaver: boolean
}

export function AlertButton({ openCallId, initialAlerted, isLoggedIn, isSaver }: Props) {
  const router = useRouter()
  const [alerted, setAlerted] = useState(initialAlerted)
  const [loading, setLoading] = useState(false)

  async function toggle(e: React.MouseEvent) {
    e.preventDefault()
    e.stopPropagation()

    if (!isLoggedIn) {
      router.push("/login")
      return
    }
    if (!isSaver) {
      router.push("/pro")
      return
    }

    setLoading(true)
    try {
      const res = await fetch("/api/alerts", {
        method: alerted ? "DELETE" : "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(
          alerted
            ? { openCallId }
            : { openCallId, type: "deadline_14" }
        ),
      })
      if (res.ok) {
        setAlerted(!alerted)
        router.refresh()
      }
    } finally {
      setLoading(false)
    }
  }

  const title = !isLoggedIn
    ? "Sign in for deadline alerts"
    : !isSaver
    ? "Saver plan required — upgrade for $4/mo"
    : alerted
    ? "Remove deadline alert"
    : "Alert me 14 days before deadline"

  return (
    <button
      onClick={toggle}
      disabled={loading}
      title={title}
      aria-label={title}
      className={`relative p-1.5 rounded-lg transition-colors disabled:opacity-50 ${
        alerted
          ? "text-amber-600 bg-amber-50"
          : "text-[var(--muted-foreground)] hover:text-amber-600 hover:bg-amber-50"
      }`}
    >
      {alerted ? <Bell size={15} fill="currentColor" /> : <Bell size={15} />}
      {!isSaver && (
        <Lock size={8} className="absolute bottom-0.5 right-0.5 text-[var(--muted-foreground)]" />
      )}
    </button>
  )
}
